export function createItemWidthCalculator(_a) {
    var getPageWidth = _a.getPageWidth, getNavWidth = _a.getNavWidth, ellipsisWidth = _a.ellipsisWidth;
    return function itemWidthCalculator(item) {
        var _a;
        if (item.type === 'page') {
            return getPageWidth(item.label, (_a = item.active) !== null && _a !== void 0 ? _a : false);
        }
        if (item.type === 'previous' || item.type === 'next') {
            return getNavWidth(item.type, item.gotoPage !== undefined);
        }
        if (item.type === 'ellipsis') {
            return ellipsisWidth;
        }
        throw Error("unknown item: ".concat(item.type));
    };
}
